var map = {
	"./assets/images/10/bg/big/01.webp": 5291,
	"./assets/images/10/bg/small/01.webp": 2989,
	"./assets/images/8/bg/big/01.webp": 5330,
	"./assets/images/8/bg/small/01.webp": 1953,
	"./assets/images/9/bg/big/01.webp": 7802,
	"./assets/images/9/bg/small/01.webp": 7556,
	"./pages/summary/assets/challenge/autogrill-basic.webp": 2320,
	"./pages/summary/assets/challenge/spagna-basic.webp": 8634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9869;